import React from 'react'
import { branch, renderComponent } from 'recompose'
import styled from '../../constants/theme'

const BasicLoader: React.FC = React.memo(
  () => (
    <Div>
      <svg
        className="loading"
        width="188px"
        height="188px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
      >
        <circle
          className="outer"
          cx="50"
          cy="50"
          r="40"
          fill="none"
          strokeWidth="10"
          strokeLinecap="round"
        />
        <circle
          className="inner"
          cx="50"
          cy="50"
          r="40"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
        >
          <animate
            attributeName="stroke-dashoffset"
            dur="2s"
            repeatCount="indefinite"
            from="0"
            to="502"
          />
          <animate
            attributeName="stroke-dasharray"
            dur="2s"
            repeatCount="indefinite"
            values="150.6 100.4;1 250;150.6 100.4"
          />
        </circle>
      </svg>
    </Div>
  ),
  () => true,
)
BasicLoader.displayName = 'BasicLoader'

const Div = styled.div(
  {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
  },
  ({ theme }) => ({
    '& .inner': {
      stroke: theme.primary,
    },
    '& .outer': {
      stroke: theme.greyLight,
    },
    backgroundColor: theme.background,
  }),
)
Div.displayName = 'Div'

export const withBasicLoader = branch(
  (props: { loading: boolean }) => props.loading,
  renderComponent(BasicLoader),
)

export const withStreamLoader = branch(
  (props: { isStreamLoading: boolean; loading: boolean }) =>
    props.isStreamLoading || props.loading,
  renderComponent(BasicLoader),
)

const LoaderDiv = styled.div(
  {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: '20px 0',
  },
  ({ theme }) => ({
    '& path': {
      fill: theme.border,
    },
  }),
)
LoaderDiv.displayName = 'LoaderDiv'

export const ContentLoaderSvg: React.FC = () => (
  <svg
    width="32"
    height="32"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <path
      className="outer"
      opacity=".25"
      d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
    />
    <path
      className="inner"
      d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 16 16"
        to="360 16 16"
        dur="0.8s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
)

export const ContentLoader: React.FC = React.memo(
  () => (
    <LoaderDiv>
      <ContentLoaderSvg />
    </LoaderDiv>
  ),
  () => true,
)
export const withContentLoader = branch(
  (props: { loading: boolean }) => props.loading,
  renderComponent(ContentLoader),
)
